import sensors from "sa-sdk-javascript";
import { getUserInfoByUserNo } from "@/api/MYINCOME";
import { getPageName } from "@/utils/MYINCOME/pageNameMap";

// 根据环境动态设置 server_url
const isProduction = process.env.REACT_APP_ENV === "production";
const serverUrl = isProduction
  ? "https://d.mingchu.co/sa?project=shinho_employee_project"
  : "https://d.mingchu.co/sa";

sensors.init({
  server_url: serverUrl,
  is_track_single_page: false, // 关闭自动采集单页面，改为手动触发
  use_client_time: true,
  send_type: "beacon",
  // show_log: true,
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: "default",
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: "not_collect", // 关闭自动采集 $WebStay，改为手动触发 PageStay
  },
});

// 从 URL 获取参数
const urlParams = new URLSearchParams(window.location.search);
const userNo = urlParams.get('userNo');

// 先注册基础属性
sensors.registerPage({
  system_platform: "PLRS-MYINCOME",
  user_code: userNo || ''
});

// 先暴露 sensors 对象，供其他组件使用
window.$sensors = { sensors };

/**
 * 发送自定义 PageView 事件
 */
const sendPageView = (userName = '') => {
  const pathname = window.location.pathname;
  sensors.track('PageView', {
    page_url: window.location.href,
    page_path: pathname,
    page_name: getPageName(pathname),
    page_title: document.title,
    user_name: userName,
  });
};

/**
 * 发送按钮点击事件
 * @param {string} buttonName - 按钮名称（如：查看）
 * @param {string} buttonDesc - 按钮备注/描述（如：销量绩效工资-202512-查看）
 * @param {string} buttonPage - 按钮所在页面
 */
export const trackButtonClick = (buttonName, buttonDesc, buttonPage) => {
  sensors.track('ButtonClick', {
    button_name: buttonName,
    button_desc: buttonDesc,
    button_page: buttonPage,
  });
};

/**
 * 获取用户信息并上报 PageView 事件（同时把 user_name 注册到全局事件属性）
 * @param {string} userNo - 工号
 * @param {string} [token] - 登录(loginNormal)换取后的 token；
 *   不传时由 axios 请求拦截器从 URL 读取（内页刷新等场景）
 * @returns {Promise<void>}
 */
export const reportUserInfo = (userNo, token) => {
  if (!userNo) {
    sendPageView();
    return Promise.resolve();
  }
  return getUserInfoByUserNo(userNo, token)
    .then(res => {
      // 注册 user_name 到所有事件中
      sensors.registerPage({
        user_name: res?.data?.userName || '',
      });
      // 发送自定义 PageView 事件
      sendPageView(res?.data?.userName || '');
    })
    .catch(err => {
      console.error('获取用户信息失败:', err);
      sendPageView();
    });
};

// 初始化阶段的上报策略：
// - 登录中转页(/)：此时 URL 携带的是原始 token，需等 loginNormal 换取新 token 后，
//   由 Loading 页调用 reportUserInfo(userNo, exchangeToken)，故此处不主动调用。
// - 内页直接加载/刷新：URL 中已是换取后的 token，可直接上报。
// - 无 userNo（非登录入口）：直接上报 PageView。
// DomReport 页面同登录中转页一样，URL 携带的是原始 token，需页面内换取后再上报，
// 故此处不主动调用 reportUserInfo，避免用原始 token 请求接口触发 "token 无效" 弹框。
const isLandingPage = window.location.pathname === '/';
const isDomReport = window.location.pathname
  .toLowerCase()
  .startsWith('/domreport');
if (!userNo) {
  sendPageView();
} else if (!isLandingPage && !isDomReport) {
  reportUserInfo(userNo);
}